import { Link } from "react-router-dom";

const KatalogUMKM = () => {
  return (
    <section className="katalog-container">
      <p className="katalogUmkmTitle">UMKM</p>

      <div className="katalog-Row">
        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <Link to="/Katalog/UMKMDetails">
            <h2>Nama UMKM</h2>
          </Link>
        </div>

        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>

        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>
      </div>

      <div className="katalog-Row">
        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>

        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>

        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>
      </div>

      <div className="katalog-Row">
        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>

        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>

        <div className="katalog-card">
          <img
            className="katalog-cardImage"
            src="http://via.placeholder.com/400"
            alt=""
          />
          <h2>Nama UMKM</h2>
        </div>
      </div>
    </section>
  );
};

export default KatalogUMKM;
